export const AUTH_HEADER: string = "Authorization";
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
export const AUTH_TOKEN_KEY: any = process.env.REACT_APP_TOKEN_KEY;
export const AUTH_USER_KEY: any = process.env.REACT_APP_ROLE_KEY;
